<template>
  <span>
    <p class="alert alert-info" v-if="!type">
      <fai icon="exclamation-triangle"></fai>
      {{ trans(module + '.' + tip) }}
    </p>
    <fai icon="exclamation-circle"></fai>
  </span>
</template>

<script>
export default {
  props: ['tip', 'module', 'type']
};
</script>
